import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IconName } from '../icon/icon-registry';
import { IconComponent } from '../icon/icon.component';
import {
  Toast,
  ToastAction,
  ToastKind,
  ToastService,
} from '../../../core/services/toast.service';

const ICONS: Record<ToastKind, IconName> = {
  error: 'alert',
  success: 'check',
  info: 'info',
  warning: 'alert',
};

/** Fixed overlay that renders the global toast queue. */
@Component({
  selector: 'app-toast-host',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  templateUrl: './toast-host.component.html',
  styleUrl: './toast-host.component.scss',
})
export class ToastHostComponent {
  private readonly toast = inject(ToastService);

  protected readonly toasts = this.toast.toasts;

  protected iconFor(kind: ToastKind): IconName {
    return ICONS[kind];
  }

  protected dismiss(item: Toast): void {
    this.toast.dismiss(item.id);
  }

  protected runAction(item: Toast, action: ToastAction): void {
    this.toast.dismiss(item.id);
    action.onClick();
  }
}
